import BaseController from "controllers/backend/base"
import { placesUri }  from "servos/googlePlaces"

import GeocompletedAddress from "widgets/geocompletedAddress"


class Controller extends BaseController {
  call() {
    bindAddressLocator.call(this);
  }
  scripts() {
    return [placesUri]
  }
};

const bindAddressLocator = function() {
  let elem = this.root.find('form')
  new GeocompletedAddress({
    root: elem,
    options: {
      types: ['address'],
      country: ['AU', 'NZ']
    }
  });
};

export default Controller;
